





















import {Vue, Component, PropSync} from 'vue-property-decorator';
import {SelectWings} from "wings-ui-components";
import {Action, Getter} from "vuex-class";
import {BlacklistItem} from "@/store/blacklists/types";

@Component({
  components: {SelectWings}
})
export default class BlackListSelection extends Vue {
  @PropSync('templateOptions') template!: any;

  // @Getter("templateObject") template: any;
  @Getter("blacklists") blacklistsList: any;
  @Action("getBlacklists") actionGetBlackLists: any;

  selectedBlacklists: number | null = null;
  blacklists: BlacklistItem[] = []

  async created() {
    await this.actionGetBlackLists();
    // if (!this.template) return
    // let item = null
    // for (const id in this.template.blacklistIds) {
    //   if (item = this.blacklistsList.find((i: any) => i.id == id)) {
    //     this.blackLists.push({
    //       id: item.id,
    //       name: item.name
    //     })
    //   }
    // }
  }

  onAddBlacklist(val: number) {
    if (!val || this.template.blacklists.find((item: BlacklistItem) => item.id == val)) return;
    const option = this.blacklistsList.find((item: BlacklistItem) => item?.id == val);
    if (!option) return;
    this.template.blacklistIds.push(val);
    this.template.blacklists.push({id: option.id, name: option.name});
    this.template.blacklistIds.sort();
    this.template.blacklists.sort((a: any, b: any) => a.id > b.id ? 1 : -1);  
  }

  onDeleteChip(sel: BlacklistItem) {
    const idx = this.template.blacklists.findIndex((item: BlacklistItem) => item.id == sel.id);
    this.template.blacklistIds.splice(idx, 1);
    this.template.blacklists.splice(idx, 1);
  }
}
